import Jwt from './jwt'
import Redirect from './redirect'
import axios from 'axios'

let http = {
  get: async (url, params = {}) => {
    const response = await axios
      .get(url, { headers: http.getHeaders(), params: params })
      .catch(http.redirectIfUnauthorized)
    return response.data
  },

  getHeaders: headers => {
    return {
      Authorization: `Bearer ${Jwt.getIdToken()}`,
      'Content-Type': 'application/json',
      ...headers,
    }
  },

  patch: async (url, data, headers) => {
    return axios
      .patch(url, data, { headers: http.getHeaders(headers) })
      .catch(http.redirectIfUnauthorized)
  },

  post: async (url, data, headers) => {
    return axios
      .post(url, data, { headers: http.getHeaders(headers) })
      .catch(http.redirectIfUnauthorized)
  },

  redirectIfUnauthorized: async error => {
    if (error.response.status === 403 || error.response.status === 401) {
      Redirect.navigate()
      return error
    } else {
      throw error
    }
  },
}

export default http
